export default {
  err_already_invited_title: 'Already invited',
  err_already_invited_message: 'There already exists a pending invitation for this clinic',
  err_invitation_existing_collaborator_title: 'Invitation sent to an existing collaborator',
  err_invitation_existing_collaborator_message: 'The clinic you are trying to invite is already registered in the platform. Try again using the clinic search feature.',
};
